@if (showBanner()) {
  <div class="system-message">
    {{ systemMessage()?.message }}
    <a rel="noopener" href="https://help.scoot.app/kb-tickets/new " target="_blank">{{ systemMessage()?.title }}</a>
  </div>
}
